import React, { useState } from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
import { orderBy } from "lodash";
import { DateRangePicker } from "react-dates";
import moment from "moment";

import CustomerSelect from "../../common/CustomerSelect";
import DepartmentSelect from "../../common/DepartmentSelect";
import UserSelect from "../../common/UserSelect";
import DropdownSearch from "../../common/DropdownSearch";

import ReportFilters from "../ReportFiltersComponent";

const SupportTicketDetailFilters = ({
  onChange,
  onChangeDate,
  filters,
  onResetClick,
  onFetchClick,
  loading,
  disabled,
  exportDisabled,
  onPDFExport,
  codes
}) => {
  const [focusedInput, setFocusedInput] = useState(null);

  const generateCodeOptions = (entity, field) => {
    const codeOptions = codes
      .filter((code) => code.entity === entity && code.field === field)
      .map((code) => ({
        value: code._id,
        label: code.label,
        order: code.order
      }));
    return orderBy(
      codeOptions,
      [(option) => option.label.toLowerCase()],
      "order"
    );
  };

  return (
    <ReportFilters
      onFetchClick={() => onFetchClick()}
      onResetClick={onResetClick}
      title="Support Tickets Detail"
      loading={loading}
      disabled={disabled}
      pdfExportAvailable
      exportDisabled={exportDisabled}
      onPDFExport={onPDFExport}
    >
      <Row>
        <Col md={3}>
          <DropdownSearch
            isMulti
            rowStyles={{ marginTop: 0 }}
            label="Ticket Status"
            placeholder="Select"
            name="request_status"
            onChange={(field, value) => onChange(field)(value)}
            value={filters.filtered.request_status || []}
            data={generateCodeOptions("Support Ticket", "status")}
          />
        </Col>
        <Col md={3}>
          <DepartmentSelect
            isMulti
            label="Department"
            placeholder="Select"
            value={filters.filtered.department || null}
            onChange={(e) => onChange("department")(e || [])}
          />
        </Col>
        <Col md={3}>
          <UserSelect
            isMulti
            label="Assigned To"
            placeholder="Select"
            value={filters.filtered.assigned_to || null}
            onChange={(e) => onChange("assigned_to")(e || null)}
          />
        </Col>
        <Col md={3}>
          <CustomerSelect
            isMulti
            label="Customer"
            placeholder="Select"
            value={filters.filtered.customer || null}
            onChange={(e) => onChange("customer")(e || [])}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: 15 }}>
        <Col md={6}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            Date Range
          </label>
          <DateRangePicker
            startDate={
              filters.filtered.start_date
                ? moment(filters.filtered.start_date)
                : null
            }
            startDateId="startDate"
            endDate={
              filters.filtered.end_date
                ? moment(filters.filtered.end_date)
                : null
            }
            endDateId="endDate"
            onDatesChange={({ startDate, endDate }) => {
              onChangeDate(startDate, endDate);
            }}
            isOutsideRange={() => false}
            focusedInput={focusedInput}
            onFocusChange={(fi) => setFocusedInput(fi)}
          />
        </Col>
        <Col md={3}>
          <DropdownSearch
            rowStyles={{ marginTop: 0 }}
            label="Location"
            placeholder="Select"
            name="location"
            onChange={(field, value) => onChange(field)(value.value)}
            value={filters.filtered.location}
            data={[
              { label: "EU", value: "EU" },
              { label: "Other", value: "other" }
            ]}
          />
        </Col>
        <Col md={3}>
          <DropdownSearch
            rowStyles={{ marginTop: 0 }}
            label="Response Due"
            placeholder="Select"
            name="response_due"
            onChange={(field, value) => onChange(field)(value.value)}
            value={filters.filtered.response_due}
            data={[
              { value: "past", label: "Past Due" },
              {
                value: "soon",
                label: "Due Soon"
              }
            ]}
          />
        </Col>
      </Row>
    </ReportFilters>
  );
};

SupportTicketDetailFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  onChangeDate: PropTypes.func,
  onResetClick: PropTypes.func,
  onFetchClick: PropTypes.func,
  filters: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  exportDisabled: PropTypes.func,
  onPDFExport: PropTypes.func,
  codes: PropTypes.array
};

SupportTicketDetailFilters.defaultProps = {
  codes: []
};

export default SupportTicketDetailFilters;
